import { createSelector } from 'reselect'
import getInsuranceCoverAmountFromCart from './getInsuranceCoverAmountFromCart'
import getInsuranceCoverAmountFromOrder from 'lib/insurance/getInsuranceCoverAmountFromOrder'

export const getTotalPriceFromExistingOrder = createSelector(
  (state: App.State) => state.checkout.cart.existingOrder,
  (order): number => {
    if (order) {
      return getInsuranceCoverAmountFromOrder(order)
    }

    return 0
  },
)
const getCheckoutInsuranceCoverAmount = createSelector(
  (state: App.State) => getInsuranceCoverAmountFromCart(state),
  (state: App.State) => getTotalPriceFromExistingOrder(state),
  (cartCoverAmount, orderCoverAmount): number => {
    return orderCoverAmount || cartCoverAmount || 0
  },
)

export default getCheckoutInsuranceCoverAmount
